'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fillArrayWithNumbers = require('../../libs/fillArrayWithNumbers');

var _fillArrayWithNumbers2 = _interopRequireDefault(_fillArrayWithNumbers);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = (0, _fillArrayWithNumbers2.default)(0, 23).map(function (hour) {
  return {
    value: hour,
    label: '' + (hour - 12 > 0 ? hour - 12 : hour) + (hour >= 12 ? 'pm' : 'am')
  };
});